import axios from '@/plugins/axios';

const state = {
  items: [],
};

const mutations = {
  setItems(currentState, items) {
    currentState.items = items.filter((fc) => fc.code.toLowerCase() !== 'test');
  },
};

const actions = ({
  getItems({ commit }) {
    return new Promise((resolve) => {
      axios.get('/finance-companies')
        .then((response) => {
          commit('setItems', response.data);
          resolve();
        });
    });
  },
});

const getters = {
  getItems() {
    return state.items;
  },
  currentFinanceCompany(localState, localGetters, rootState) {
    return localState.items.find((l) => l.code === rootState.currentLenderCode);
  },
  replicaAvailable(localState, localGetters) {
    return !!localGetters.currentFinanceCompany?.allowedReplicaLenders?.length;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
